import type { MusinsaStandardResponse } from '@musinsa/packages-http';
import { executeStandardRequest } from '@musinsa/packages-http';
import { z } from 'zod';
import { publicHttpClient } from '../httpClient';
import { linkApiPath } from './apiPath';

const GetCuratorShopLinkRequestParamsSchema = z
  .object({
    snsTitle: z.string().min(1),
  })
  .describe('GetCuratorShopLinkRequestParamsSchema');

type GetCuratorShopLinkRequestParams = z.infer<typeof GetCuratorShopLinkRequestParamsSchema>;

const GetCuratorShopLinkResponseDataSchema = z
  .object({
    platform: z.enum(['MUSINSA', '29CM']),
    originUrl: z.string(),
    shortUrl: z.string(),
  })
  .describe('GetCuratorShopLinkResponseDataSchema');

type GetCuratorShopLinkResponseData = z.infer<typeof GetCuratorShopLinkResponseDataSchema>;

type GetCuratorShopLinkResponse = MusinsaStandardResponse<GetCuratorShopLinkResponseData>;

/**
 * 큐레이터샵 링크 조회 (`GET /v2/link/curator/shop`).
 *
 * `snsTitle` 로 큐레이터샵의 origin URL (UTM 파라미터 포함) / 단축 URL 을 조회.
 * 인증 불필요. `X-Platform` 헤더 기반으로 플랫폼(MUSINSA / 29CM) 자동 감지.
 *
 * - 200: 조회 성공
 * - 400: 지원하지 않는 플랫폼
 * - 404: 큐레이터샵 또는 링크 없음 (ACTIVATED 상태만 조회 대상)
 */
export const getCuratorShopLink = (params: GetCuratorShopLinkRequestParams) =>
  executeStandardRequest(() =>
    publicHttpClient.get<GetCuratorShopLinkResponse>(linkApiPath.getCuratorShopLink, params),
  );
